import { render } from "./ContractDefinitionFields.vue?vue&type=template&id=1481373c"
import script from "./ContractDefinitionFields.vue?vue&type=script&lang=js"
export * from "./ContractDefinitionFields.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__